export const API_ROOT_URL = process.env.REACT_APP_API_ROOT_URL;
export const LOCAL_STORAGE_KEY = 'cookmatic-store';
export const INITIAL_USER_STATE = {};
export const NAV_WIDTH = '-200px';
export const DEFAULT_TAG_COLOR = '#ededed';